module.exports = "#define GLSLIFY 1\n#ifdef USE_DISPLACEMENTMAP\n\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n\n#endif\n"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderChunk/displacementmap_pars_vertex.glsl
// module id = 226
// module chunks = 0